import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "short", timeStyle: "short" }) : "-");

// Daftar HP yang sedang login di app mobile untuk armada ini + tombol Cabut.
export const TechDevicesList = ({ techId }) => {
  const [items, setItems] = useState(null);
  const load = useCallback(() => api.techDevices(techId).then((r) => setItems(r.items)).catch(() => setItems([])), [techId]);
  useEffect(() => { load(); }, [load]);

  const revoke = async (d) => {
    if (!window.confirm(`Cabut akses HP "${d.device_name || d.device_id}"? HP itu harus login ulang.`)) return;
    try { await api.revokeTechDevice(techId, d.device_id); toast.success("Akses HP dicabut"); load(); }
    catch { toast.error("Gagal mencabut akses"); }
  };

  return (
    <div className="border-t border-border pt-3" data-testid="tech-devices-list">
      <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold mb-1.5">HP yang login di app mobile</div>
      {items === null ? <div className="text-xs text-zinc-400">Memuat…</div>
        : !items.length ? <div className="text-xs text-zinc-400" data-testid="tech-devices-empty">Belum ada HP yang login.</div>
        : items.map((d) => (
          <div key={d.device_id} className="flex items-center gap-2 py-1.5 text-xs" data-testid={`tech-device-${d.device_id}`}>
            <Smartphone className="w-4 h-4 text-zinc-500 flex-none" />
            <div className="flex-1 min-w-0">
              <div className="font-semibold truncate">{d.device_name || "HP tanpa nama"}</div>
              <div className="text-[10px] text-zinc-500">Terakhir aktif {fmt(d.last_used_at)} · berlaku s/d {fmt(d.expires_at)}</div>
            </div>
            <Button size="sm" variant="outline" className="h-7 rounded-sm text-red-600" onClick={() => revoke(d)}
              data-testid={`tech-device-revoke-${d.device_id}`}>Cabut</Button>
          </div>
        ))}
      <div className="text-[10px] text-zinc-400 mt-1">Ganti password = semua HP wajib login ulang.</div>
    </div>
  );
};
